import HtmlTrans from 'components/shared/HtmlTrans';
import { LinkText } from 'components/shared/LinkText';
import { Heading3 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { StyledContainer } from './BringYourOwnTeamCommitment.styled';

const BringYourOwnTeamCommitment: React.FC = () => {
  const { t } = useI18n('bring-your-own-team');
  const { locale } = useRouter();

  return (
    <StyledContainer>
      <Heading3 editorial>{t('commitment.title')}</Heading3>
      <p>
        <HtmlTrans
          ns={'bring-your-own-team'}
          i18nKey={'commitment.desc'}
          components={{
            ethic: (
              <LinkText
                href={`${getAppUrl(
                  APP_URLS.blog,
                  locale
                )}/compromiso-etico-manfred`}
              />
            )
          }}
        />
      </p>
    </StyledContainer>
  );
};

export default BringYourOwnTeamCommitment;
